<template>
  <div class="container programZone">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ zone.name }}
    </h1>

    <h2 class="subtitle">{{ $t("program.zone") }}</h2>
    <button @click="save" class="button is-success">
      {{ $t("buttons.save") }}
    </button>
    <br /><br />
    <program v-if="program" :program="program"></program>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Program from "../../../../components/shared/Program";
import constants from "../../../../config/constants";

export default {
  components: { Program },
  name: "zone-program",
  data() {
    return {
      program: null,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
    }),

    ...mapState("zones", {
      zone: "current",
    }),
  },
  methods: {
    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
      setProgram: "setProgram",
    }),

    save: function () {
      return new Promise((resolve) => {
        this.setProgram({ zone: this.zone, program: this.program }).then(() => {
          resolve();
        });
      });
    },

    goBack: function () {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1]
      );
    },

    loadZone: function () {
      this.setInstallation(this.$route.params.id)
        .then(() => {
          this.setZone(this.$route.params.idZone).then(() => {
            this.program =
              this.zone.schedule !== undefined
                ? Object.values(this.zone.schedule)
                : constants.defaultProgram;
          });
        })
        .catch(() => {
          this.$router.push("/installations");
        });
    },
  },
  created() {},
  mounted() {
    this.loadZone();
  },
};
</script>

<style lang="scss" scoped>
h1.title {
  margin: 3rem 0 5rem;
  text-align: left;
}

.container {
  max-width: 100%;
}

.programZone {
  padding: 0 2rem 2rem;
}
</style>
